// Vendor
import { CommonModule } from '@angular/common';
// Modules
import { ConfigModule } from 'NewAngular/config/config.module';
import { HoldingsHistoryTableModule } from 'SecuritiesApp/ts/features/holdings-history-table/holdings-history-table.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class HoldingsHistoryModule {
}
HoldingsHistoryModule.ɵfac = function HoldingsHistoryModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsHistoryModule)(); };
HoldingsHistoryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsHistoryModule });
HoldingsHistoryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ConfigModule, HoldingsHistoryTableModule, ModuleUpsellModule] });
